module.exports = __webpack_public_path__ + "static/primary-coaches-sm-mobile-d922e1b947001cc135cce352dc121bd8.jpg";